import dynamic from 'next/dynamic';
import getConfig from 'next/config';
import { LinkButton } from '../../../../Toolkit/Button/LinkButton';
import { useModal } from '../shared/FinanceModal/FinanceModal.hook';
import { type Provider } from '../../../queries/schema/carFinance.schema';
import { type LearnMoreModalProps } from './components/LearnMoreModal/LearnMoreModal';
import { Header, ProviderLogo, Heading } from './Introduction.styled';

const DynamicLearnMoreModal = dynamic<LearnMoreModalProps>(
  import('./components/LearnMoreModal/LearnMoreModal').then(
    (mod) => mod.LearnMoreModal,
  ),
  { ssr: false },
);

type IntroductionProps = {
  provider: Provider;
  isStepOne: boolean;
};

const Introduction = ({ provider, isStepOne }: IntroductionProps) => {
  const {
    publicRuntimeConfig: { CDN_STATIC_ASSETS },
  } = getConfig();
  const {
    isModalOpen: isLearnMoreModalOpen,
    openModal: openLearnMoreModal,
    closeModal: closeLearnMoreModal,
  } = useModal();

  return (
    <div>
      {isStepOne && (
        <Header>
          <div style={{ minWidth: 0 }}>
            <Heading>Apply for finance</Heading>
            <LinkButton onClick={openLearnMoreModal} inline>
              Learn about the process
            </LinkButton>
          </div>
          <ProviderLogo
            src={`${CDN_STATIC_ASSETS}/images/thirdparty/${provider}.svg`}
            alt={`${provider} logo`}
          />
        </Header>
      )}
      <DynamicLearnMoreModal
        isOpen={isLearnMoreModalOpen}
        onRequestClose={closeLearnMoreModal}
        provider={provider}
      />
    </div>
  );
};

export { Introduction };
